/* unplugin-vue-components disabled */import script from "./PBSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./PBSelect.vue?vue&type=script&setup=true&lang=js"

import "./PBSelect.vue?vue&type=style&index=0&id=950e7442&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-950e7442"]])

export default __exports__